import { Component, OnInit } from "@angular/core";
import { PedidoService } from "src/app/core/services/pedido-service";
import Swal from "sweetalert2";
import { Order } from "src/app/core/entities/order";
import { Configuracoes } from "src/app/core/entities/configuracoes";
import { ConfiguracoesSite } from "src/app/core/entities/configuracoesSite";
import { ProductService } from "src/app/core/services/product-service";
import { ActivatedRoute, Router } from "@angular/router";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { ToastrService } from "ngx-toastr";
declare var $: any;

@Component({
  selector: "app-page-carrinho",
  templateUrl: "./page-carrinho.component.html",
  styleUrls: ["./page-carrinho.component.css"],
})
export class PageCarrinhoComponent implements OnInit {
  SITE: ConfiguracoesSite;

  public modo = 1;
  public idDelete: number = 0;
  public idDeleteModo2;
  public API_IMAGENS: String;
  public API_IMAGENS_PRODUTOS: String;
  public pedidoItens = [];
  public idPedidoDelete
  public loadingUpload: boolean = false
  public pedidoItensFiltrado = [];
  public pedidoItensQuantSum = 0;
  public pedidoItensPrecoSum = 0;
  public pedidoItensPrecoSumComImp = 0;
  public pedidoClienteSelected;
  public pedido: Order;
  //public mapProdutos;
  public selectedIds = []
  public form: FormGroup;
  public term: string = ""

  /*public arr = ['1030039409016', '1030039400013', '5019106700016', '5019106710015', '0040010030734', '2310010030736', '0040010030741', '2310010030743', '0169107450740', '0040010030758', '0169107450757', '0040010030765', '0169107450764', '0040010880766', '0550010040737', '0050010040756', '0050010040787', '0050010040732', '0040010040733', '0169107380733', '0040010040740', '0550010040744', '0050010040749', '0169107380740', '0040010040764', '0550010040768', '2310010040766', '0050010040763', '0169107380764', '0040010040757', '0040010040955', '0550010040751', '0040105040952', '0040105040785', '0050105040784', '0040105040747', '0050105040746', '0550105040741', '0040105040761', '0050105040760', '0550105040765', '0040105040754', '0050105040753', '0550105040758', '0040105040730', '0050105040739', '0550105040734', '0050010870742', '0040010870767', '0050010870766', '0050010870759', '0040180560734', '0040180560741', '0040180560758', '0040180560765', '0040181260954', '0040181260787', '0040181260015', '0040181260749', '0559000060748', '0040181260763', '0559000060762', '0040181260732', '0559000060731', '0040181260756', '0559000060755', '0040018000951', '0040018000784', '0040018000739', '0550018000733', '0050018000738', '0040018000753', '0550018000757', '0050018000752', '0040018000746', '0550018000740', '0050018000745', '0040018000760', '0050018000769', '0040108060766', '0040018010950', '0040018012589', '0040018010783', '0040018010738', '0550018010732', '0050018010737', '0040018010752', '0550018010756', '0050018010751', '0040018010745', '0550018010749', '0050018010744', '0040018010769', '0050018010768', '0040018010912', '0040187580742', '0040187580766', '0040187580759', '0040181280952', '0040181280785', '0040181280747', '0559000080746', '0040181280761', '0559000080760', '0040181280730', '0559000080739', '0040181280754', '0559000080753', '0040018050734', '0040018050741', '0040018050758', '0040018050765', '0040018050956', '0040018230730', '0040018230747', '0040018230754', '0040018230761', '0040018230952', '0040018230785', '0040011410764', '0050011410763', '0040011410740', '0050011410749', '0040018250745', '0040018250752', '0040018250769', '0040018250950', '0040018250783', '0040018252589', '0040018250738', '0040018130955', '0040018130719', '0040018132584', '0440018130788', '0040018130740', '0559000100741', '0040018130764', '0559000100765', '0040018130733', '0559000100734', '0040018130757', '0559000100758', '0041875100747', '0041875100754', '0041875100761', '0040018020959', '0040018020782', '0040018020737', '0550018020731', '0050018020736', '0040018020751', '0550018020755', '0050018020750', '0040018020744', '0550018020748', '0050018020743', '0040018020768', '0050018020767', '0040018020010', '0040018022588', '0040018140954', '0040018140718', '0040018142583', '0040018140749', '0559000120749', '0040018140763', '0559000120763', '0040018140732', '0559000120732', '0040018140756', '0559000120756', '0040018030743', '0550018030747', '0040018030736', '0550018030730', '0040018030750', '0550018030754', '0040018030767', '0040018032587', '0019103572581', '0040018030958', '0040018030781', '0040018070763', '0040018070954', '0040018070749', '0051688120740', '0040018070756', '0051688120757', '0040018070732', '0040018820733', '0040018820740', '0040018820757', '0040018820764', '5019102920012', '5019102922252', '4089109200111', '4089109200043', '4089109200098', '4089109200241', '4089109200173'];
  public tipoUsuario;
  public index = 0;
  test01(){
    if(this.arr[this.index]){
      let barra = this.arr[this.index];
      this.form.controls.codigoBarras.setValue(barra);
      this.onSubmit();
      console.log(barra, this.index);
      this.index++;
      setTimeout(()=>{    
        this.test01();
      }, 500);
    }
  }*/

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public pedidoService: PedidoService,
    public productService: ProductService,
    public toastService: ToastrService,
    private formBuilder: FormBuilder
  ) {
    this.SITE = Configuracoes.SITE;
    this.API_IMAGENS = Configuracoes.API_IMAGENS;
    this.API_IMAGENS_PRODUTOS = Configuracoes.API_IMAGENS_PRODUTOS;
    //this.tipoUsuario = window.localStorage.getItem('tipoUsuario');
    this.route.queryParams.subscribe((params) => {
      if (this.SITE.carrinhoCodigoBarras) {
        if (params["modo"]) {
          this.modo = params["modo"];
        } else {
          let cartModo = parseInt(window.localStorage.getItem("cartModo"));
          if (cartModo != null && cartModo >= 1 && cartModo <= 2) {
            this.modo = cartModo;
          } else {
            this.modo = 1;
          }
        }
      } else {
        this.modo = 1;
      }
      this.init();
    });
    this.form = this.formBuilder.group({
      codigoBarras: ["", Validators.required],
    });
  }

  ngOnInit() {
    // this.pedidoItens = this.pedidoItens.map(i => ({...i, produtoReferencia: i.produtoreferencia}))
    $(function () {
      $("#codigoBarras").focus();
      $(window).scrollTop(
        $("#gcc-header").height() + $("#gcc-slider-superior").height()
      );
    });
  }

  init() {
    if (this.pedidoService.pedido) this.notify(this.pedidoService.pedido);
  }

  toRoute(modo) {
    this.router.navigate(["carrinho"], { queryParams: { modo: modo } });
    window.localStorage.setItem("cartModo", modo);
  }

  onFileSelected(event: any): void {
    this.loadingUpload = true
    event.preventDefault();
    const formData = new FormData();
    formData.append('file', event.target.files[0]);
    this.productService.importaProdutos(
      this.pedido.id,
      formData,
      function (resp) {
        if(resp.listaItensErro.length > 0){
          for(let i = 0; i < resp.listaItensErro.length; i++){
            this.toastService.error("Erro ao incluir item: "+resp.listaItensErro[i].EAN);
          }
        }
        this.notify(resp);
        this.pedidoService.select(resp);
        event.target.value = "";
        this.loadingUpload = false
      }.bind(this),
      (err: any) => {
        event.target.value = "";
        this.loadingUpload = false
        if (err._body) {
          Swal.fire(
            $localize`Produtos`,
            $localize`Erro no upload: ` + JSON.parse(err._body).detail,
            "error"
          );
        } else {
          Swal.fire(
            $localize`Produtos`,
            $localize`Algo deu errado. Tente novamente mais tarde`,
            "error"
          );
        }

      }
    )
  }

  onSubmit() {
    if (!this.form.valid) {
      return;
    }
    this.pedidoService.codigoBarras(
      this.pedido.id,
      {
        codigoBarras: this.form.value.codigoBarras,
        uf: this.pedido.clientes[0].cliente.cidade.uf,
        tabela: this.pedido.tabela.id,
        cliente: this.pedido.clientes[0].cliente.id,
      },
      function (resp) {
        if (resp.error) {
          this.toastService.error(resp.error);
        } else {
          this.pedido = resp.pedido;
          if (resp.info == 1) {
            this.toastService.success(this.form.controls.codigoBarras.value);
          } else if (resp.info == 2) {
            this.toastService.info(this.form.controls.codigoBarras.value);
          } else if (resp.info == 3) {
            this.toastService.warning(this.form.controls.codigoBarras.value);
          }
          this.pedidoService.select(resp.pedido);
          this.form.controls.codigoBarras.setValue("");
        }
      }.bind(this),
      function (error) {
        this.toastService.error($localize`Não encontrado`);
        this.form.controls.codigoBarras.setValue("");
      }.bind(this)
    );
    // }
  }

  notify(pedido: Order) {
    if (!pedido) return;

    //console.log(pedido);

    this.pedido = pedido;
    if (this.modo == 1) {
      /*this.mapProdutos = {};
      this.pedido.itens.forEach(i => {
        this.mapProdutos[i['produto'] as any] = null;
      });
      //this.productService.findByMap(this.mapProdutos, function(resp){
        if(resp){
          this.mapProdutos = resp;
          console.log('mapProdutos', resp);
          
        }
      }.bind(this));*/
      this.pedidoClienteSelected = { todos: true };
      this.pedido.clientes.forEach(
        (pc) => (this.pedidoClienteSelected[pc.cliente["id"]] = true)
      );
      this.atualizaPedidoItens();
    }
  }

  filterItem(){   
    let arr = this.pedidoItens
    this.pedidoItensFiltrado = arr.filter(i => i.produtoDescricao.includes(this.term.toUpperCase()) || i.produtoReferencia.includes(this.term.toUpperCase()) )
  }
  toggleSelectAll(checked: boolean): void {
    if (checked) {
      this.selectedIds = this.pedidoItensFiltrado.map(i => ({
        produto: i.produto,
        cliente: i.pedidocliente_id
      }));
    } else {
      this.selectedIds = [];
    }
  }
  
  toggleSelection(event: any, item: any): void {
    if (event.target.checked) {
      this.selectedIds.push({
        produto: item.produto,
        cliente: item.pedidocliente_id
      });
    } else {
      this.selectedIds = this.selectedIds.filter(
        x => !(x.produto === item.produto && x.cliente === item.pedidocliente_id)
      );
    }
  }
  
  

  isSelected(produtoId: number): boolean {
    return this.selectedIds.some(x => x.produto === produtoId);
  }

  atualizaPedidoItens() {
    this.pedidoItens = [];
    this.pedidoItensQuantSum = 0;
    this.pedidoItensPrecoSum = 0;
    this.pedidoItensPrecoSumComImp = 0;
    this.pedidoItensFiltrado = []
    let mapClientes = {};
    for (let key of Object.keys(this.pedidoClienteSelected)) {
      if (key != "todos") {
        if (this.pedidoClienteSelected[key]) mapClientes[key] = 1;
      }
    }
    let map = this.pedidoService.mapaPedidoItensPorProduto(
      this.pedido.itens,
      mapClientes
    );
    this.pedidoItens = map.itens;
    this.pedidoItensFiltrado = map.itens
    this.pedidoItensQuantSum = map.quant;
    this.pedidoItensPrecoSum = map.preco;
    this.pedidoItensPrecoSumComImp = map.precoComImposto;
  }

  changePedidoClienteSelectedTodos() {
    if (this.pedidoClienteSelected.todos) {
      for (var i = 0; i < this.pedido.clientes.length; i++) {
        this.pedidoClienteSelected[this.pedido.clientes[i]["cliente"]["id"]] =
          true;
      }
    } else {
      for (var i = 0; i < this.pedido.clientes.length; i++) {
        this.pedidoClienteSelected[this.pedido.clientes[i]["cliente"]["id"]] =
          false;
      }
    }
    this.atualizaPedidoItens();
  }

  changePedidoClienteSelected() {
    this.pedidoClienteSelected.todos = true;
    for (var i = 0; i < this.pedido.clientes.length; i++) {
      if (
        !this.pedidoClienteSelected[this.pedido.clientes[i]["cliente"]["id"]]
      ) {
        this.pedidoClienteSelected.todos = false;
        break;
      }
    }
    this.atualizaPedidoItens();
  }

  removeItem() {
    if (!this.idDelete) return;
    
    this.pedidoService.removeCartItem(
      this.idDelete,
      function (resp) {
        //console.log(pedido);
        //this.notify(pedido);
        //this.pedidoService.refresh();
        this.notify(resp);
        this.pedidoService.select(resp);
      }.bind(this), this.idPedidoDelete
    );
  }
  excluiItems(e){
    e.preventDefault()
    for(let i = 0; i < this.selectedIds.length; i++){
      this.pedidoService.removeCartItem(
        this.selectedIds[i].produto,
        function (resp) {
          //console.log(pedido);
          //this.notify(pedido);
          //this.pedidoService.refresh();
          this.selectedIds.shift()
          this.notify(resp);
          this.pedidoService.select(resp);
          this.term = ""
          this.pedidoItensFiltrado = this.pedidoItens
        }.bind(this), this.selectedIds[i].cliente
      );
    }
  }
  removeItemModo2() {
    if (!this.idDeleteModo2) return;

    this.pedidoService.codigoBarrasDel(
      this.pedido.id,
      this.idDeleteModo2,
      function (resp) {
        this.pedido = resp;
        this.pedidoService.select(resp);
        this.toastService.success($localize`Item removido!`);
      }.bind(this)
    );
  }

  confirmDel(item) {
    this.idDelete = item.produto;
    this.idPedidoDelete = item.pedidocliente_id
  }

  confirmDelModo2(id) {
    this.idDeleteModo2 = id;
  }
}
